import { Epic, Task } from '@amzn/awscat-pattern-library-service-model';

class EpicCsvEntry {
  private epic: Epic;
  private epicRank: number;
  private task: Task;
  private taskRank: number;

  constructor(epic: Epic, epicRank: number, task?: Task, taskRank?: number) {
    this.epic = epic;
    this.epicRank = epicRank;
    // @ts-expect-error TS2322 - strict migration
    this.task = task;
    // @ts-expect-error TS2322 - strict migration
    this.taskRank = taskRank;
  }

  get epicId(): string {
    return this.epic.id;
  }
  get epicTitle(): string {
    return this.epic.title;
  }
  get epicOrder(): number {
    return this.epicRank;
  }
  get epicDescription(): string {
    return this.epic.description;
  }
  get taskId(): string {
    // @ts-expect-error TS2322 - strict migration
    return this.task ? this.task.id : null;
  }
  get taskName(): string {
    // @ts-expect-error TS2322 - strict migration
    return this.task ? this.task.title : null;
  }
  get taskOrder(): number {
    return this.taskRank;
  }
  get taskDescription(): string {
    // @ts-expect-error TS2322 - strict migration
    return this.task ? this.task.description : null;
  }
  get taskSkills(): string {
    // @ts-expect-error TS2322 - strict migration
    return this.task ? this.task.skills : null;
  }
}

export default EpicCsvEntry;
